import { Button } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TAB_NOTES_MODE } from '../index';
import { TAB_NOTES_CREATE_FORM } from '../CreateNoteForm';
import { actionToggleTabNotesMode } from 'store/root/actions/messages';

const NotesFooter = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state) => {
    return {
      tabNotesMode: state.messagesReducer.tabNotesMode,
      notesTabIsLoading: state.messagesReducer.notesTabIsLoading,
    };
  });
  const { tabNotesMode, notesTabIsLoading } = messages;

  const listMode = (
    <div className="notes-footer__new-note-wrapper">
      <Button
        className="notes-footer__new-note-btn"
        block
        type="link"
        size="small"
        title="New internal note"
        onClick={() => dispatch(actionToggleTabNotesMode())}
      >
        + New internal note
      </Button>
    </div>
  );

  const createMode = (
    <div className="notes-footer--create">
      <Button
        type="link"
        size="small"
        title="Cancel"
        disabled={notesTabIsLoading}
        onClick={() => dispatch(actionToggleTabNotesMode())}
      >
        Cancel
      </Button>
      <Button
        type="link"
        size="small"
        title="Save"
        htmlType="submit"
        disabled={notesTabIsLoading}
        loading={notesTabIsLoading}
        form={TAB_NOTES_CREATE_FORM}
      >
        Send
      </Button>
    </div>
  );

  return <>{tabNotesMode === TAB_NOTES_MODE.LIST ? listMode : createMode}</>;
};

export default NotesFooter;
